// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table .el-image[data-v-6098b449]{width:auto !important;height:30px !important}.table[data-v-6098b449] ::v-deepel-image__inner,.table .el-image__placeholder[data-v-6098b449],.table .el-image__error[data-v-6098b449]{width:auto !important}.info[data-v-6098b449]{width:63%}", ""]);
// Exports
module.exports = exports;
